<template>
  <v-row align="center">
    <v-col
      cols="12"
      md="6"
    >
      <div v-if="def.label">
        {{ $t(def) }}
      </div>
    </v-col>
    <v-col
      cols="12"
      md="6"
      class="d-flex justify-end"
    >
      <v-radio-group
        v-bind="$attrs"
        v-model="Model[def.name]"
        fluid
        :row="!!def.label"
        v-on="$listeners"
      >
        <v-radio
          v-for="(n, index) in items"
          :key="index"
          :label="n.DisplayText"
          :value="n.ID"
        ></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AppMultiRadioButton",
  props: ["def", "model", "items"],
  data: function() {
    return {
      Model: this.model
    }
  }
}
</script>